import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MachinesService } from 'src/app/_services/machines.service';
import { MessService } from 'src/app/_services/mess-service.service';

@Component({
  selector: 'app-machins-add',
  templateUrl: './machins-add.component.html',
  styleUrls: ['./machins-add.component.scss'],
})
export class MachinsAddComponent implements OnInit {
  // roles: any[];
  // selectedRole: Role;
  form: FormGroup;

  subscriptions: Subscription[] = [];

  allOperations = [];
  selectedOpterations = [];

  constructor(
    private fb: FormBuilder,
    private machineService: MachinesService,
    private messService: MessService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    this.form = this.fb.group({
      name: [''],
      code: [''],
      serial_number: [''],
      operations: [[]],
    });

    /**
     * Get all operations
     */
    this.subscriptions.push(
      this.machineService.getAllOperations().subscribe((res) => {
        this.allOperations = res;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  /* ====================================
  *             MAIN FEATURES
  ======================================= */
  onSubmit() {
    let operationsArray = this.form.get('operations').value;
    let formData = this.form.getRawValue();

    /**
     * Change operations array from array to object with key "id"
     */
    operationsArray.forEach((element, index) => {
      const obj = {};
      obj['id'] = element;
      this.selectedOpterations.push(obj);
    });

    this.form.patchValue({
      operations: this.selectedOpterations,
    });

    formData = this.form.getRawValue();
    this.subscriptions.push(
      this.machineService.addMachine(formData).subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešno kreiranje',
            detail: 'Uspešno ste dodali novog korisnika.',
          });
          this.router.navigate(['./../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.form;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  addOperatios(event, field) {
    this.form.patchValue({
      [field]: event.value,
    });
  }
}
